import * as React from 'react';
import { PokerHandResult } from '../game/poker-hand-checker';
import { PlayingCard } from './PlayingCard';

type HandResultProps = {
    result: PokerHandResult;
};

export function HandResult({ result }: HandResultProps) {
    return (
        <div className='result message'>
            <header>&#127881; {result.match} &#127881;</header>
            <div className='cards'>{result.cards.map(c => <span key={c.rank + c.suit}>
                <PlayingCard rank={c.rank} suit={c.suit} top={"0"} left={"0"} height={"4em"} onClick={() => undefined} /></span>)}
            </div>
            <div> - {result.points} Points - </div>
            {result?.bonus && <div>&#127881; {result?.bonus} Bonus for clearing board &#127881;</div>}
        </div>
    );
}
